module.exports = __webpack_public_path__ + "img/pr-13.6adcec26.png";